import type { Lpu } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_types'
import type { RatingStatItem } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuRating/types'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'

function toStatValue(value: number | null | undefined): number | null {
  return value === undefined ? null : value
}

/**
 * Списки метрик клиники и врачей для детализации рейтинга.
 */
export default function getLpuRatingStats(lpu: Lpu): {
  clinicStats: RatingStatItem[]
  doctorsStats: RatingStatItem[]
} {
  const { lpustat, rating_clinic: ratingClinic, lputype } = lpu
  const foodTitle = lputype.is_hospital
    ? tStatic('Качество питания')
    : tStatic('Время ожидания')

  const clinicStats: RatingStatItem[] = [
    {
      key: 'rating_clinic',
      title: tStatic('Популярность клиники'),
      value: toStatValue(ratingClinic),
      isLargeScale: true,
    },
    {
      key: 'building',
      title: tStatic('Здание и помещение'),
      value: toStatValue(lpustat?.building),
    },
    {
      key: 'equipment',
      title: tStatic('Оборудование и медикаменты'),
      value: toStatValue(lpustat?.equipment),
    },
    {
      key: 'medstaff',
      title: tStatic('Отношение медперсонала'),
      value: toStatValue(lpustat?.medstaff),
    },
    {
      key: 'leisure',
      title: tStatic('Комфорт пребывания'),
      value: toStatValue(lpustat?.leisure),
    },
    {
      key: 'food',
      title: foodTitle,
      value: toStatValue(lpustat?.food),
    },
  ]

  const doctorsStats: RatingStatItem[] = [
    {
      key: 'doctors_osmotr',
      title: tStatic('Обследование'),
      value: toStatValue(lpustat?.doctors_osmotr),
    },
    {
      key: 'doctors_efficiency',
      title: tStatic('Эффективность лечения'),
      value: toStatValue(lpustat?.doctors_efficiency),
    },
    {
      key: 'doctors_friendliness',
      title: tStatic('Отношение к пациенту'),
      value: toStatValue(lpustat?.doctors_friendliness),
    },
    {
      key: 'doctors_informativity',
      title: tStatic('Информирование'),
      value: toStatValue(lpustat?.doctors_informativity),
    },
    {
      key: 'doctors_recommend',
      title: tStatic('Посоветуете ли врача?'),
      value: toStatValue(lpustat?.doctors_recommend),
    },
  ]

  return {
    clinicStats,
    doctorsStats,
  }
}
